import React, { useState } from 'react';
import { ArrowRight, Copy, Check } from 'lucide-react';
export function UsefulLinks() {
  const [copied, setCopied] = useState(false);
  const handleCopyCode = () => {
    navigator.clipboard.writeText('stressless');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  const links = [{
    text: 'Proefpakket bestellen',
    url: 'https://www.anifit.com/content/dierenvoeding/shop/shop/article/284458/proefpakket_hond_400g_1_set_met_verschillende_soorten_natvoer_vlokken_en_testpakketten_?new_client_country=NL&category=62183&refconsultant=487050'
  }, {
    text: 'Power-Darm voor darmherstel',
    url: 'https://www.anifit.com/content/dierenvoeding/shop/shop/article/398758/powerdarm_60g_1_stuk_?new_client_country=NL&category=62183&refconsultant=487050'
  }, {
    text: 'Standaard Omschakelpakket',
    url: 'https://www.anifit.com/content/dierenvoeding/shop/shop/article/165810?new_client_country=NL&category=62183&refconsultant=487050'
  }, {
    text: 'Bio Rundvlees',
    url: 'https://www.anifit.com/content/dierenvoeding/shop/shop/article/40683/rydog_vitaal_menu_biologisch_rundvlees_400g_6_stuk_?new_client_country=NL&category=62183&refconsultant=487050'
  }, {
    text: 'Gans',
    url: 'https://www.anifit.com/content/dierenvoeding/shop/shop/article/423439/bio_gans_met_geluk_400g_6_stuk_?new_client_country=NL&category=62183&refconsultant=487050'
  }, {
    text: 'Gezonde Snacks',
    url: 'https://www.anifit.com/content/dierenvoeding/shop/shop/articles/62193?new_client_country=NL&category=62183&refconsultant=487050'
  }, {
    text: 'Volledig Natvoer Assortiment',
    url: 'https://www.anifit.com/content/dierenvoeding/shop/shop/articles/62183?new_client_country=NL&category=62183&refconsultant=487050'
  }];
  return <section className="py-16 bg-gray-50" data-id="element-249">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-250">
        <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center" data-id="element-251">
          Linkjes naar Anifit
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 max-w-5xl mx-auto" data-id="element-252">
          {links.map((link, index) => <a key={index} href={link.url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-700 hover:text-[#4DBFB8] transition-colors p-3 bg-white rounded-lg shadow-sm hover:shadow-md" data-id="element-253">
              <ArrowRight className="w-4 h-4 text-[#4DBFB8]" data-id="element-254" />
              <span className="font-medium" data-id="element-255">{link.text}</span>
            </a>)}
        </div>

        <div className="text-center mt-10" data-id="element-256">
          <button onClick={handleCopyCode} className="inline-flex items-center gap-2 bg-[#4DBFB8] text-white px-6 py-2 rounded-full font-bold shadow-md hover:bg-[#3da8a2] transition-colors cursor-pointer" data-id="element-257">
            <span data-id="element-258">
              Vergeet niet: gebruik code "stressless" voor 10% korting!
            </span>
            {copied ? <Check className="w-4 h-4" data-id="element-259" /> : <Copy className="w-4 h-4" data-id="element-260" />}
          </button>
          {copied && <p className="text-sm text-[#4DBFB8] mt-2 font-medium" data-id="element-261">
              ✓ Code gekopieerd!
            </p>}
        </div>
      </div>
    </section>;
}